module.exports = __webpack_public_path__ + "media/images/team/tati-f03d5d7e3306b02ddd49850f841d21a3.jpg";